import "./latest-updates.scss";
document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".tab");
  const sections = document.querySelectorAll(".resource-results");

  tabs.forEach((tab, index) => {
    tab.addEventListener("click", () => {
      // Remove 'active' class from all tabs and sections
      tabs.forEach((t) => t.classList.remove("active"));
      sections.forEach((s) => s.classList.remove("active"));
      tabs.forEach(t => t.setAttribute('aria-selected', 'false'));

      // Add 'active' class to the clicked tab and corresponding section
      tab.classList.add("active");
      sections[index].classList.add("active");
      tab.setAttribute('aria-selected', 'true');

      // Handle Swiper reinitialization
      const swiperContainer =
        sections[index].querySelector(".swiper-container");
      if (swiperContainer) {
        const existingSwiper = swiperContainer.swiper;
        if (existingSwiper) {
          existingSwiper.destroy(true, true); // Destroy the existing Swiper instance
        }

        // Reinitialize Swiper
        new Swiper(swiperContainer, {
          slidesPerView: "auto",
          spaceBetween: 25,
          autoHeight: true,
          loop: swiperContainer.querySelectorAll(".swiper-slide").length > 3,
          navigation: {
            prevEl: `.slider-prev-${swiperContainer.getAttribute(
              "data-slider-id"
            )}`,
            nextEl: `.slider-next-${swiperContainer.getAttribute(
              "data-slider-id"
            )}`
          },
          breakpoints: {
            0: {
              slidesPerView: 1,
              spaceBetween: 10
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 15
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 25
            }
          }
        });
      }
    });


    // Add keyboard navigation functionality
    tab.addEventListener('keydown', function(e) {
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
          // Move to the next tab
          const nextTab = tabs[index + 1] || tabs[0];
          nextTab.focus();
          nextTab.click(); // Simulate click
      } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
          // Move to the previous tab
          const prevTab = tabs[index - 1] || tabs[tabs.length - 1];
          prevTab.focus();
          prevTab.click(); // Simulate click
      } else if (e.key === 'Enter' || e.key === ' ') {
          // Select the tab on Enter or Space key
          tab.click();
      }
    });

  });


  if (typeof window.resourceCardHandlers === 'undefined') {
    window.resourceCardHandlers = {
        handleLanguageClick: function(event, element) {
            event.preventDefault();
            event.stopPropagation();
            const url = element.getAttribute('data-language-url');
            if (url) {
                window.location.href = url;
            }
        }
    };
  }

});







